import { IVideo, IVideoComment } from '@connec10/media-interface/src/entity'
import { IonIcon, IonText } from '@ionic/react'
import { chevronBackOutline, chevronForwardOutline } from 'ionicons/icons'
import React, { useMemo, useState } from 'react'
import { useMediaQuery } from 'react-responsive'
import { Playlist } from '..'
import { useGetVideoList } from '../../../modules/video'
import { SP_MAX_WIDTH } from '../../../setting'
import { Box, Colors } from '../../atoms'
import { MainContentCard } from '../../molecules'

type Size = number | string
export interface CourseProps {
  width?: Size
  height?: Size
  maxWidth?: Size
  video: IVideo
  commentList?: IVideoComment[]
  pdfUrl?: string
}

export const Course = ({ width = '100%', height, video, commentList, pdfUrl }: CourseProps) => {
  const [isFullScreen, setIsFullScreen] = useState(false)
  const { videos } = useGetVideoList({ termId: video.term.id })
  const isSp = useMediaQuery({
    query: `(max-device-width: ${SP_MAX_WIDTH})`
  })

  // 右側の横幅は PDF の向きに応じて変える
  const rightSideWidth = useMemo(() => {
    return video.term.textbookOrientation === 'LANDSCAPE' ? '46' : '33'
  }, [video.term.textbookOrientation])

  const toggleRightSection = () => {
    setIsFullScreen(!isFullScreen)
  }

  return (
    <Box maxWidth="1200px" width="100vw" mx="auto" px={isSp ? '0px' : '32px'}>
      {!isSp && (
        <Box width="100%" display="flex" justifyContent="flex-end" transition="256ms">
          <Box p="16px" cursor="pointer" onClick={toggleRightSection} display="flex" alignItems="center">
            <IonText>
              <p style={{ color: Colors.secondary.default, margin: 0, fontSize: '13px', fontWeight: 600 }}>
                {!isFullScreen ? 'プレイリストを隠す' : 'プレイリストを表示'}
              </p>
            </IonText>
            <Box display="flex" alignItems="center" ml="4px">
              <IonIcon
                icon={!isFullScreen ? chevronForwardOutline : chevronBackOutline}
                style={{ color: Colors.secondary.default, fontSize: '16px' }}
              />
            </Box>
          </Box>
        </Box>
      )}

      <Box width={width} height={height} display="flex">
        <Box width="100%">
          {video && <MainContentCard videoHeight="60vh" video={video} videoCommentList={commentList} />}
        </Box>
        {!isSp && (
          <Box
            display="flex"
            flexDirection="column"
            width={!isFullScreen ? `${rightSideWidth}vw` : '0%'}
            minWidth={!isFullScreen ? `${rightSideWidth}%` : '0%'}
            maxWidth={!isFullScreen ? `${rightSideWidth}%` : '0%'}
            flex="0 1 auto"
            ml={!isFullScreen ? '32px' : '0px'}
            transition="256ms"
            opacity={!isFullScreen ? '100' : '0'}
          >
            {/* {pdfUrl && (
              <Box mb="16px">
                <PdfViewer width="100%" url={pdfUrl} video={video} />
              </Box>
            )} */}
            <Box>
              <Playlist courseList={videos} currentId={video.id} />
            </Box>
          </Box>
        )}
      </Box>
    </Box>
  )
}
